import { IBwjBillboardProps } from "../../framework/components/bwj-billboard";
import { BwjButtonType } from "../../framework/components/bwj-button";
import { ErrorRobotGraphic } from "../../graphics/error-robot";

export const useStandardErrorState = () => {

  const props: IBwjBillboardProps = {
    graphic: ErrorRobotGraphic,
    graphicPortraitOriented: true,
    message: 'Uh oh... Something just went wrong.  Please reload this page',
    buttons: [{
      buttonStyle: BwjButtonType.PrimaryStandard,
      text: 'Reload page',
      onClick: () => window.location.reload(),
    }],
  };

  return props;
}